import React from "react";
import PropTypes from "prop-types";

const ActivityCount = ({ value }) => {
  if (value > 0) {
    return (
      <span className="activity-count">{value}</span>
    );
  }

  return null;
};

ActivityCount.propTypes = {
  value: PropTypes.number.isRequired,
};

export default ActivityCount;
